/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import { post, CashRequestOptions } from '@cash-web/shared-util-fetch'
import {CreateLightningInvoiceRequest} from '@cash-web/protos/squareup/cash/cashliteorchestrator/api/v1beta1/orchestrator.pb'
import {CreateLightningInvoiceResponse} from '@cash-web/protos/squareup/cash/cashliteorchestrator/api/v1beta1/orchestrator.pb'


export const createLightningInvoice = (request: CreateLightningInvoiceRequest, options?: CashRequestOptions) => post<CreateLightningInvoiceRequest, CreateLightningInvoiceResponse>("/2.0/cash/create-lightning-invoice", request, {...options, rejectOnError: true })